'use client';
import { useState, useEffect } from 'react';
import Image from "next/image";

export default function LoadingScreen() {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const exitTimer = setTimeout(() => setIsExiting(true), 800);
    const removeTimer = setTimeout(() => setIsVisible(false), 800);
    return () => {
      clearTimeout(exitTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!isVisible) return null;
  
  return (
    <>
      <style jsx global>{`
        @keyframes customShimmer {
          0% { transform: translateX(-100%) skewX(-12deg); }
          100% { transform: translateX(200%) skewX(-12deg); }
        }
        @keyframes customProgress {
          0% { transform: translateX(-100%); width: 30%; }
          50% { width: 60%; }
          100% { transform: translateX(400%); width: 20%; }
        }
      `}</style>

      <div className="fixed inset-0 z-999 flex flex-col items-center justify-center bg-dark px-6 font-sans overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:32px_32px] pointer-events-none" />
        <div className="relative flex flex-col items-center max-w-sm w-full text-center space-y-8 z-10">
          <div className="relative w-42 h-42 flex items-center justify-center">
            <div className="absolute inset-0 border border-[#c22738]/20 rotate-45 scale-110 animate-[spin_8s_linear_infinite]" />
            <div className="absolute inset-2 border-l border-r border-[#c22738]/10 -rotate-45 animate-[spin_12s_linear_infinite_reverse]" />
            <div className="absolute inset-2 border-t border-b border-[#c22738]/10 -rotate-45 animate-[spin_12s_linear_infinite_reverse]" />
            <div className="w-32 h-32 relative backdrop-blur-sm shadow-xl flex flex-wrap">
              <div className="w-1/2 h-1/2" />
              <div className="absolute inset-0 flex items-center justify-center">
                <Image
                  src={'/images/gss_white_logo.png'}
                  alt={`screenshot`}
                  className="h-auto md:justify-self-center mt-2"
                  width={200}
                  height={100}
                // style={imageStyle}
                />
              </div>
            </div>
          </div>
          <div className="space-y-2 select-none">
            <h2 className="text-2xl font-bold tracking-[0.15em] text-gray-400 uppercase">
              General Swiss Services
            </h2>
            <p className="text-sm text-gray-500 font-medium tracking-wide">
              Fabriqué à Genève Qualité <span className="text-[#c22738] font-medium">Suisse</span>
            </p>
          </div>
          <div className="w-32 h-[2px] bg-gray-100 rounded-full overflow-hidden relative">
            <div
              className="absolute top-0 bottom-0 left-0 bg-[#c22738] rounded-full"
              style={{ animation: 'customProgress 0.8s cubic-bezier(0.65, 0.05, 0.36, 1) infinite' }}
            />
          </div>
        </div>
      </div>
    </>
  );
}